import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-modal_close",
  "use": "icon-modal_close-usage",
  "viewBox": "0 0 12.98 12.98",
  "content": "<symbol viewBox=\"0 0 12.98 12.98\" id=\"icon-modal_close\">\r\n    <path d=\"M0,1.18,1.18,0,13,11.8,11.8,13ZM11.8,0,13,1.18,1.18,13,0,11.8Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/modal_close.svg
// module id = GKKS
// module chunks = 0